import $ from "jquery";
import * as types from '../actions/actionTypes';
import {
  MODULE_CONTEXT_MENU_TYPES,
  MODULE_CONTEXT_MENU_DIRECTIONS,
  CABINET_WIZARD_BUTTONS,
  COUNTERTOP_WIZARD_BUTTONS,
  CABINET_GROUP, COUNTERTOP_GROUP, EDGE_GROUP
}
  from "../bvcomponents/kvComponent/core/constants";
import {
  COUNTERTOP_GROUP_BATHROOM,
  HANDLES_GROUP_BATHROOM,
  SHOWER_FLOOR_GROUP_BATHROOM
} from "../bvcomponents/bvSceneComponent/core/constants";

const isNewBathroomOrKitchen = document.kvConfig.toolVersion >= 5;

const initialState = {
  mobileNav: [],
  desktopNavigationOpened: false,
  navigationViewType: 3,
  activeNavigationParentName: "",
  activeNavigationChildName: "",
  // partId of the feature group the fullscreen docked visualizer should frame (see
  // setVisualizerCanvasPartId). "" = nothing specific / idle framing.
  visualizerCanvasPartId: "",
  navigationLoadingActive: false,  // to show when features are already downloaded
  moduleContextMenuType: MODULE_CONTEXT_MENU_TYPES.Filters,
  moduleContextMenuDirection: MODULE_CONTEXT_MENU_DIRECTIONS.Vertical,
  moduleContextMenuModule: null,
  moduleContextMenuModulePart: null,
  // cabinet module filters
  activeNavigationFilter: CABINET_WIZARD_BUTTONS[0].buttonId,
  activeNavigationFilterStepIndex: 0,
  cabinetNavigationFilterCompleted: false,
  countertopNavigationFilterCompleted: false,
  counterTopWizard: { // not needed for now, but probably we would need this logic in future
    [COUNTERTOP_WIZARD_BUTTONS[0].buttonId]: "All",
    [COUNTERTOP_WIZARD_BUTTONS[1].buttonId]: "All",
  },
  edgesApplyTo: EDGE_GROUP,
  cabinetsApplyTo: CABINET_GROUP,
  cabinetsApplyToBathroom: isNewBathroomOrKitchen ? [] : ["vanity_cabinet", "vanity_mirror"], // porselanosa enable matching countertops
  countertopsApplyToArray: COUNTERTOP_GROUP, // is used on lixil UI
  countertopsApplyToArrayBathroom: COUNTERTOP_GROUP_BATHROOM, // is used on lixil UI
  handlesApplyToBathroom: HANDLES_GROUP_BATHROOM,
  showerFloorApplyToBathroom: SHOWER_FLOOR_GROUP_BATHROOM,
  countertopsApplyTo: {
    "countertop": ["center_island_countertop", "backsplash"],
    "center_island_countertop": ["countertop", "backsplash"],
    "backsplash": ["center_island_countertop", "countertop"]
  },
  countertopsApplyToBathroom: {
    "vanity_countertop": ["vanity_backsplash"],
    "vanity_backsplash": ["vanity_countertop"]
  },
  useFeaturesLightRequest: {
    countertops: true,
    cabinets: true,
  },
  updateDisableFeatureGroupRadio: false,
  navItemPositionModal: {
    popupOpened: false,
    popupPosition: {},
    activePartId: ""
  }
};

export default function(state = initialState, action) {
  let newState = {...state};
  switch(action.type) {
    case types.LOAD_MOBILE_NAV:
      newState.mobileNav = [...action.payload];
    break;
    case types.SET_ACTIVE_NAVIGATION_NAMES:
      if (action.payload.activeNavigationParentName === "walls"
        || action.payload.activeNavigationParentName === "cabinet") {
        switch (action.payload.activeNavigationChildName) {
          case "ceiling":
          case "right_wall":
          case "popout_wall":
          case "left_wall":
          case "crown_molding":
          case "top_cabinet":
            $('html, body').animate({scrollTop: 0}, 500);
            break;
        }
      }
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.TOGGLE_DESKTOP_NAVIGATION:
    case types.SET_NAVIGATION_VIEW_TYPE:
    case types.SET_MODULE_CONTEXT_MENU_TYPE:
    case types.SET_MODULE_CONTEXT_MENU_DIRECTION:
    case types.SET_MODULE_CONTEXT_MENU_MODULE:
    case types.SET_MODULE_CONTEXT_MENU_MODULE_PART:
    case types.SET_ACTIVE_NAVIGATION_FILTER:
    case types.SET_ACTIVE_NAVIGATION_FILTER_STEP_INDEX:
    case types.SET_CABINET_NAVIGATION_FILTER_COMPLETED:
    case types.SET_COUNTERTOP_NAVIGATION_FILTER_COMPLETED:
    case types.SET_NAVIGATION_LOADING:
    case types.SET_VISUALIZER_CANVAS_PART_ID:
    case types.UPDATE_DISABLE_FEATURE_GROUP_RADIO:
    case types.SET_APPLY_TO_COMMON:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_COUNTERTOP_WIZARD:
      return Object.assign({}, state, {
        counterTopWizard: Object.assign({}, state.counterTopWizard, action.payload.countertopWizard)
      });
    case types.SET_CABINETS_APPLY_TO:
      return Object.assign({}, state, {
        cabinetsApplyTo: [...action.payload.cabinetsApplyTo]
      });
    case types.SET_EDGES_APPLY_TO:
      return Object.assign({}, state, {
        edgesApplyTo: [...action.payload.edgesApplyTo]
      });
    case types.SET_CABINETS_APPLY_TO_BATHROOM:
      return Object.assign({}, state, {
        cabinetsApplyToBathroom: [...action.payload.cabinetsApplyToBathroom]
      });
    case types.SET_COUNTERTOPS_APPLY_TO:
      if (action.payload.newArrayLogic) {
        return Object.assign({}, state, {
          countertopsApplyToArray: [...action.payload.countertopsApplyTo]
        });
      }
      return Object.assign({}, state, {
        countertopsApplyTo: Object.assign({}, state.countertopsApplyTo, action.payload.countertopsApplyTo)
      });
    case types.SET_COUNTERTOPS_APPLY_TO_BATHROOM:
      if (action.payload.newArrayLogic) {
        return Object.assign({}, state, {
          countertopsApplyToArrayBathroom: [...action.payload.countertopsApplyToBathroom]
        });
      }
      return Object.assign({}, state, {
        countertopsApplyToBathroom: Object.assign({}, state.countertopsApplyToBathroom, action.payload.countertopsApplyToBathroom)
      });
    case types.TOGGLE_NAV_ITEM_POSITION_MODAL:
      return Object.assign({}, state, {
        navItemPositionModal: Object.assign({}, state.navItemPositionModal, action.payload.navItemPositionModal)
      });
    case types.SET_USE_FEATURES_LIGHT_REQUEST:
      return Object.assign({}, state, {
          countertopsApplyToArray: !action.payload.useFeaturesLightRequest.countertops ? [] : state.countertopsApplyToArray,
          cabinetsApplyTo: !action.payload.useFeaturesLightRequest.cabinets ? [] : state.cabinetsApplyTo,
          useFeaturesLightRequest: Object.assign({}, state.useFeaturesLightRequest, action.payload.useFeaturesLightRequest)
      });
  }
  return newState;
}
